module.exports = __webpack_public_path__ + "img/printer-icon-black.caab879f.svg";